/**
 * Site menu — full-screen navigation on narrow screens, unveiled from the
 * top by the burger. The markup is the server's (templates/site/chrome/
 * menu.html.twig).
 *
 * @module chrome/menu
 */

import { $, $$ } from '../lib/dom.js';
import { gsap } from '../lib/gsap.js';
import { getSmoother } from '../lib/scroll.js';

export function animateMenu() {
    const burger = $('[data-burger]');
    const menu = $('.site-menu');

    if (!burger || !menu) {
        return;
    }

    const links = $$('.site-menu__list a', menu);
    const footerLinks = $$('.site-menu__footer a', menu);
    let open = false;

    const timeline = gsap
        .timeline({ paused: true, onReverseComplete: () => gsap.set(menu, { visibility: 'hidden' }) })
        .set(menu, { visibility: 'visible' })
        .fromTo(
            menu,
            { clipPath: 'inset(0 0 100% 0)' },
            { clipPath: 'inset(0 0 0% 0)', duration: 0.65, ease: 'power4.inOut' },
        )
        .from(links, { yPercent: 110, duration: 0.6, stagger: 0.05 }, '-=0.3')
        .from(footerLinks, { opacity: 0, y: 12, duration: 0.4, stagger: 0.04 }, '-=0.35');

    /** @param {boolean} state */
    const setOpen = (state) => {
        open = state;
        burger.classList.toggle('is-open', open);
        burger.setAttribute('aria-expanded', String(open));

        // With ScrollSmoother the body no longer scrolls: pause the smoother
        // instead of touching the body's overflow.
        const smoother = getSmoother();

        if (smoother) {
            smoother.paused(open);
        } else {
            document.body.style.overflow = open ? 'hidden' : '';
        }

        if (open) {
            timeline.play();
        } else {
            timeline.reverse();
        }
    };

    burger.addEventListener('click', () => setOpen(!open));

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && open) {
            setOpen(false);
        }
    });

    // A link navigates (the veil takes over), but release the scroll lock
    // in case navigation is cancelled.
    links.forEach((link) => {
        link.addEventListener('click', () => getSmoother()?.paused(false));
    });
}
